class ElementLineIndexer {
	protected elements!: NodeListOf<HTMLElement>|HTMLElement[];
	protected lineIndex: number;

	constructor(elements?: NodeListOf<HTMLElement>|HTMLElement[]) {
		if (elements) {
			this.elements = elements;
		}
		this.lineIndex = -1;
	}

	get highestLineIndex(): number {
		return this.lineIndex;
	}

	getElements(): NodeListOf<HTMLElement> | HTMLElement[] {
		return this.elements;
	}

	setElements(elements: NodeListOf<HTMLElement> | HTMLElement[]): void {
		this.elements = elements;
	}

	async index(): Promise<IndexedLineCollection> {
		this.lineIndex = -1;

		const rows: HTMLElement[][] = [];
		let top = Number.NEGATIVE_INFINITY;

		return new Promise<IndexedLineCollection>( resolve => {
			this.elements.forEach((i, index) => {
				let ref = i;
				const baseEl = i.closest(".line-index-base");
				if (baseEl instanceof HTMLElement) {
					ref = baseEl;
				}
				const itemTop = ref.getBoundingClientRect().top;
				const isNewRow = itemTop > top;

				if (isNewRow) {
					this.lineIndex++;
					top = itemTop;
					rows[this.lineIndex] = [];
				}

				i.dataset.lineIndex = this.lineIndex.toString();

				if (baseEl instanceof HTMLElement) {
					baseEl.dataset.lineIndex = this.lineIndex.toString();
				}
				
				rows[this.lineIndex].push(i);
			});

			resolve({
				rows: rows,
				lineIndex: this.lineIndex
			});
		});
	}


}

export interface IndexedLineCollection {
	rows: HTMLElement[][];
	lineIndex: number;
}

export default ElementLineIndexer;
